import React, { Fragment, useEffect } from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
//import Clearfix from '../../components/UI/Clearfix/Clearfix';
// Sections for this page
import CuentoData from '../../components/CuentoPage/CuentoData';

import articuloPageStyle from '../../assets/jss/coscef/views/articuloPageStyle';

const useStyles = makeStyles(articuloPageStyle);

const CuentoPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <CuentoData {...props} />
      </div>
      <div className={classes.section}></div>
    </Fragment>
  );
};

export default CuentoPage;
